export default "__VITE_ASSET__5a512f9f__"